import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Slide,
    IconButton,
    Typography,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { fetchCategorias } from '../../services/empleados.api';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TareasForm = ({ open, handleClose, handleSubmit, initialData }) => {
    const [formData, setFormData] = useState({
        categoria_id: '',
        nombre: ''
    });
    const [categorias, setCategorias] = useState([]);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const loadCategorias = async () => {
            try {
                const data = await fetchCategorias();
                setCategorias(data.data || []);
            } catch (error) {
                console.error("Error loading categorias for TareasForm:", error);
            }
        };
        loadCategorias();
    }, []);

    useEffect(() => {
        if (initialData) {
            setFormData({
                categoria_id: initialData.categoria_id || '',
                nombre: initialData.nombre || ''
            });
        } else {
            setFormData({
                categoria_id: '',
                nombre: ''
            });
        }
        setErrors({});
    }, [initialData, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };

    const validate = () => {
        const newErrors = {};
        
        if (!formData.nombre.trim()) {
            newErrors.nombre = "El nombre es obligatorio";
        } else if (formData.nombre.trim().length > 100) {
            newErrors.nombre = "El nombre no puede exceder los 100 caracteres";
        }

        if (!formData.categoria_id) {
            newErrors.categoria_id = "La categoría es obligatoria";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            handleSubmit(formData);
        }
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: { borderRadius: 15, padding: '10px' }
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {initialData ? 'Editar Tarea' : 'Nueva Tarea'}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ color: (theme) => theme.palette.grey[500] }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={onSubmit}>
                <DialogContent dividers>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth error={!!errors.categoria_id}>
                                <InputLabel>Categoría</InputLabel>
                                <Select
                                    name="categoria_id"
                                    value={formData.categoria_id}
                                    label="Categoría"
                                    onChange={handleChange}
                                >
                                    {categorias.map(cat => (
                                        <MenuItem key={cat.id_categoria} value={cat.id_categoria}>
                                            {cat.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.categoria_id && (
                                    <Box sx={{ color: 'error.main', fontSize: '0.75rem', px: 2, mt: 0.5 }}>
                                        {errors.categoria_id}
                                    </Box>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="nombre"
                                label="Nombre de la Tarea"
                                fullWidth
                                variant="outlined"
                                value={formData.nombre}
                                onChange={handleChange}
                                error={!!errors.nombre}
                                helperText={errors.nombre}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={handleClose} color="inherit" variant="text">
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained" color="primary" sx={{ boxShadow: 3 }}>
                        {initialData ? 'Actualizar' : 'Guardar'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default TareasForm;
